import React from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import { enhancedConnect } from "../../../utils";
import styles from "./styles.pcss";
import { cnSection } from "../../utils/side";
import { SectionSide } from "../../utils/side/types";
var cn = classNames.bind(styles);
var _CardImage = function _CardImage(_ref) {
  var align = _ref.align,
    _ref$side = _ref.side,
    side = _ref$side === void 0 ? SectionSide.vAuto : _ref$side,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'content' : _ref$type,
    src = _ref.src,
    alt = _ref.alt,
    className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    className: cn('image', align && "align--".concat(align), cnSection({
      side: side
    }), styles["side--".concat(side)], {
      asBackground: (type === null || type === void 0 ? void 0 : type.indexOf('background-')) !== -1
    }, {
      cover: (type === null || type === void 0 ? void 0 : type.indexOf('-cover')) !== -1
    }, {
      contain: (type === null || type === void 0 ? void 0 : type.indexOf('-contain')) !== -1
    }, className)
    // style={{ backgroundUrl: src }}
    ,
    "data-t-id": "Card-CardImage"
  }, /*#__PURE__*/React.createElement("div", {
    className: cn('imageIn')
  }, /*#__PURE__*/React.createElement("img", {
    alt: alt,
    src: src
  })));
};
export var CardImage = enhancedConnect({
  /**
   * В будущем может быть расширено на left, right, hMiddle (для горизонтальных карточек)
   * vAuto - использует first-child/last-child, для указания отступа
   */
  side: PropTypes.oneOf(Object.values(SectionSide)),
  align: PropTypes.oneOf(['center', 'left', 'right']),
  type: PropTypes.oneOf(['image-cover', 'image-contain', 'content', 'background-cover', 'background-contain']),
  src: PropTypes.string,
  alt: PropTypes.string,
  className: PropTypes.string
})(_CardImage);